module.exports = __webpack_public_path__ + "img/event_app.c10601c.jpg";